import { ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE } from 'fhir/constants'
import { ServiceTypeName } from 'fhir/HealthcareService/constants'

export const APPOINTMENT_CHANGE_REASON_EXTENSION = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/appointment-change-reason`

export enum AppointmentType {
  CNA_VISIT = 'cna-visit',
  HHA_STANDARD_SHIFT = 'hha-standard-shift',
  PCP_STANDARD_SHIFT = 'pcp-standard-shift',
  RPCP_STANDARD_SHIFT = 'rpcp-standard-shift',
  HMA_STANDARD_SHIFT = 'hma-standard-shift',
  HMK_STANDARD_SHIFT = 'hmk-standard-shift',
  LRP_HMK_STANDARD_SHIFT = 'lrp-hmk-standard-shift',
  RSP_STANDARD_SHIFT = 'rsp-standard-shift',
  SCC_STANDARD_SHIFT = 'scc-standard-shift',
  CC_STANDARD_SHIFT = 'cc-standard-shift',
  HMK_E_EC_STANDARD_SHIFT = 'hmk-e-ec-standard-shift',
  SFC_STANDARD_SHIFT = 'sfc-standard-shift',
  ATTC_STANDARD_SHIFT = 'attc-standard-shift',
  HCA_STANDARD_SHIFT = 'hca-standard-shift',
  GA_PSS_STANDARD_SHIFT = 'ga-pss-standard-shift',

  // These are pulled from `axlehealth/constants.py`
  START_OF_CARE = 'start-of-care',
  RECERTIFICATION = 'recertification',
  DELEGATION = 'delegation',
  SUPERVISORY_VISIT = 'supervisory-visit',
  VIRTUAL_RECERTIFICATION = 'virtual-recertification',
  ONE_YEAR_PAR = '1-year-par',
  RESUMPTION_OF_CARE = 'resumption-of-care',
  IN_PERSON_PAT = 'in-person-pat',
  ACUTE = 'acute'
}

// Service type can only be directly determined from caregiver appointment types
export const ApointmentTypeToServiceType: Record<string, string> = {
  [AppointmentType.CNA_VISIT]: 'CNA',
  [AppointmentType.HHA_STANDARD_SHIFT]: 'HHA',
  [AppointmentType.PCP_STANDARD_SHIFT]: 'PCP',
  [AppointmentType.RPCP_STANDARD_SHIFT]: 'RPCP',
  [AppointmentType.HMA_STANDARD_SHIFT]: 'HMA',
  [AppointmentType.HMK_STANDARD_SHIFT]: 'HMK',
  [AppointmentType.LRP_HMK_STANDARD_SHIFT]: 'LRP-HMK',
  [AppointmentType.RSP_STANDARD_SHIFT]: 'RSP',
  [AppointmentType.SCC_STANDARD_SHIFT]: 'SCC',
  [AppointmentType.CC_STANDARD_SHIFT]: 'CC',
  [AppointmentType.HMK_E_EC_STANDARD_SHIFT]: 'HMK-E/EC',
  [AppointmentType.SFC_STANDARD_SHIFT]: 'SFC',
  [AppointmentType.ATTC_STANDARD_SHIFT]: 'ATTC',
  [AppointmentType.HCA_STANDARD_SHIFT]: 'HCA',
  [AppointmentType.GA_PSS_STANDARD_SHIFT]: 'PSS'
}

export const getServiceTypeFromAppointmentType = (
  appointmentType: string,
  patientState: string | null | undefined
): ServiceTypeName | undefined => {
  const serviceTypeSuffix = ApointmentTypeToServiceType[appointmentType]
  if (!serviceTypeSuffix || !patientState) return undefined

  const serviceType = `${patientState.toUpperCase()}-${serviceTypeSuffix}`
  return Object.values(ServiceTypeName).includes(serviceType as ServiceTypeName)
    ? (serviceType as ServiceTypeName)
    : undefined
}

export const CAREGIVER_VISIT_APPOINTMENT_TYPES = [
  AppointmentType.CNA_VISIT,
  AppointmentType.HHA_STANDARD_SHIFT,
  AppointmentType.PCP_STANDARD_SHIFT,
  AppointmentType.RPCP_STANDARD_SHIFT,
  AppointmentType.HMA_STANDARD_SHIFT,
  AppointmentType.HMK_STANDARD_SHIFT,
  AppointmentType.LRP_HMK_STANDARD_SHIFT,
  AppointmentType.RSP_STANDARD_SHIFT,
  AppointmentType.SCC_STANDARD_SHIFT,
  AppointmentType.CC_STANDARD_SHIFT,
  AppointmentType.HMK_E_EC_STANDARD_SHIFT,
  AppointmentType.SFC_STANDARD_SHIFT,
  AppointmentType.ATTC_STANDARD_SHIFT,
  AppointmentType.HCA_STANDARD_SHIFT,
  AppointmentType.GA_PSS_STANDARD_SHIFT
]

export enum AppointmentStatus {
  BOOKED = 'booked',
  FULFILLED = 'fulfilled',
  CANCELLED = 'cancelled',
  NOSHOW = 'noshow',
  ENTERED_IN_ERROR = 'entered-in-error',
  PROPOSED = 'proposed'
}

export const AUTHORIZED_APPOINTMENT_STATUSES = [
  AppointmentStatus.BOOKED,
  AppointmentStatus.FULFILLED,
  AppointmentStatus.CANCELLED,
  AppointmentStatus.NOSHOW,
  AppointmentStatus.PROPOSED
]
